import { SealCheck } from "@phosphor-icons/react";

// Purple "SocialPulse verified" badge shown next to members who signed in via
// SocialPulse SSO — subtly evangelising cross-brand identity across the family.
export function SocialPulseBadge({ verified, className = "", showLabel = true }) {
  if (!verified) return null;
  return (
    <span
      data-testid="socialpulse-badge"
      title="Identity verified across the SocialPulse family"
      className={`inline-flex items-center gap-1 rounded-full bg-[#6d28d9]/10 px-2 py-0.5 text-xs font-medium text-[#6d28d9] ${className}`}
    >
      <SealCheck size={13} weight="fill" />
      {showLabel && <span>SocialPulse verified</span>}
    </span>
  );
}

export default SocialPulseBadge;
